import { render, staticRenderFns } from "./CompanyInvoices.vue?vue&type=template&id=9ad514bc&"
import script from "./CompanyInvoices.vue?vue&type=script&lang=js&"
export * from "./CompanyInvoices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports